
      import UploadFile from './upload-file.vue'
      import type { App, Plugin } from 'vue'

      export const UploadFilePlugin: Plugin = {
        install(app: App) {
          app.component('UploadFile', UploadFile)
        },
      }
      export { UploadFile }
      